import React from 'react';

import ContentViewComponent from '#app/Component/ContentViewComponent';
import List from '#app/View/Shop/Sale/ShopSalesList/components/List';
import Search from '#app/View/Shop/Sale/ShopSalesList/components/Search';
import useOrderClientList from '#app/View/Shop/Sale/ShopSalesList/hooks/useOrderClientList';

const ShopSalesList: React.FC = () => {
  const { setFilters, ...props } = useOrderClientList();

  return (
    <ContentViewComponent breadcrumbs={{ title: 'Liste des ventes', context: 'Vente' }}>
      <Search handleSearch={(data) => setFilters(data)} />
      <List {...props} />
    </ContentViewComponent>
  );
};

export default ShopSalesList;
